import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { PartnershipOverviewComponent } from '../../../common/CMS/components/PartnershipOverviewComponent';
import { requestHelpers } from "../../../../helpers";
import { PartnershipOverviewPlaceholderComponent } from "../../../common/placeholders/PartnershipOverviewPlaceholderComponent";
import BackButton from "../../../dashboardNew/components/tools/BackButton";
import ThemePageBanner from "../../../dashboardNew/components/ThemePageBanner";

class PartnersOverviewPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			companies: null,
			currentPage: 1,
			totalPages: null,
			initialLoad: true,
			isLoading: true,
			category: '',
			fullDescription: ''
		};
	}

	componentWillMount() {
		let page = this.props.location.query.page;
		const href = window.location.href.split('/')[4]
		const hrefCat = href.split('?')[0]
		this.setState({ category: hrefCat })
		this.getNextPartnership(page ? page : 1);
	}

	componentWillUpdate(nextProps, nextState) {
		if (this.props.location.query.page !== nextProps.location.query.page && !nextState.initialLoad) {
			this.getNextPartnership(nextProps.location.query.page, true);
		}
	}

	componentWillUnmount() {
		this.isCancelled = true;
	}

	getNextPartnership(page, top = false) {
		this.setState({ isLoading: true });
		this.makeRequest(page);
		this.state.companies && this.state.initialLoad && this.setState({ initialLoad: false });
		browserHistory.push(`${this.props.location.pathname}?page=${page}${top ? "#topoflist" : ''}`);
	}

	//Add these queries to request URl to sort by name ascending: orderby=title&order=asc
	makeRequest = (page) => {
		requestHelpers
			.getWordPressData(`https://blog.intouchnetworks.com/wp-json/wp/v2/pages/?categories=18&per_page=20&page=${page}`)
			.then(response => {
				const array = [];
				response.data.map(item => {
					if (item.category === this.state.category) {
						array.push(item)
					}
				})
				this.setState({
					companies: array,
					totalItems: response.headers.totalItems,
					totalPages: response.headers.totalPages,
					currentPage: page,
					isLoading: false
				});
			});
		requestHelpers
			.getWordPressData(`https://blog.intouchnetworks.com/wp-json/wp/v2/pages/?slug=category-overview`)
			.then(response => {
				response.data.map(cat => {
					if (cat.title.replace(/\s/g, "-") === this.state.category) {
						this.setState({
							fullDescription: cat.full_description
						});
					}
				})
			});
	};


	render() {
		//Hacky way of displaying (via mapping through) 9 placeholder objects
		let placeholderArray = [1, 2, 3, 4, 5, 6, 7, 8, 9];
		let name = this.state.category.replace(/-/g, " ")
		return (
			<div className="container-fluid theme-page-content-wrapper partners-page">
				<ThemePageBanner
					image='/images/home-tiles-profile.jpg'
					heading={`Partnerships - ${name}`}
				/>
				<div className="container">
					<div className="row">
						<div className="col-12 heading-section no-margin">
							<p className='body-copy'>{this.state.fullDescription}</p>
						</div>
						<div className="col-12 back-button-hold">
							<BackButton
								title="Back to Partnerships"
								path="/partnerships-overview"
							/>
						</div>
						{this.state.companies && !this.state.isLoading && (
							this.state.companies.map((company, i) => {
								return (
									<PartnershipOverviewComponent
										description={company.description}
										header={company.title}
										primaryColor={company.primaryColor}
										buttonTextColor={company.primaryTextColor}
										secondaryColor={company.secondaryColor}
										logo={company.logo}
										button={company.button}
										link={`${this.props.location.pathname}/${company.link}`}
										key={i}
									/>
								)
							})
						)}
						{this.state.isLoading && (
							placeholderArray.map((company, i) => {
								return <PartnershipOverviewPlaceholderComponent key={i} />
							})
						)}
					</div>
				</div>
			</div>
		);
	}
}

export default PartnersOverviewPage;

PartnersOverviewPage.propTypes = {
	companies: PropTypes.array,
	pagenation: PropTypes.object,

};



// WEBPACK FOOTER //
// src/client/components/site/features/partnerships/PartnersOverviewPage.js